import { render, staticRenderFns } from "./BillTransactions.vue?vue&type=template&id=83e21a6a"
import script from "./BillTransactions.vue?vue&type=script&lang=js"
export * from "./BillTransactions.vue?vue&type=script&lang=js"
import style0 from "./BillTransactions.vue?vue&type=style&index=0&id=83e21a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports